import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FallCosineIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M23 21C18.61 21 17.24 16.12 16.03 11.81C14.88 7.7 13.98 5 12 5C10.02 5 9.12 7.7 7.97 11.81C6.76 16.12 5.4 21 1 21C0.45 21 0 20.55 0 20C0 19.45 0.45 19 1 19C3.68 19 4.73 15.94 6.04 11.27C7.18 7.2 8.36 3 12 3C15.64 3 16.82 7.2 17.96 11.27C19.27 15.94 20.33 19 23 19C23.55 19 24 19.45 24 20C24 20.55 23.55 21 23 21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FallCosineIcon.displayName = 'FallCosineIcon';
